'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { UrlTracker } from '@/lib/url-tracker'

/**
 * Component to automatically track URL changes for 404 fallback
 * Should be included in the root layout
 */
export default function UrlTrackerComponent() {
  const pathname = usePathname()

  useEffect(() => {
    // Track the current URL
    UrlTracker.trackCurrentUrl()
  }, [pathname])

  // This component doesn't render anything
  return null
}
